<div #FATHER>
  <span style="font-size: medium;font-weight: normal" #CHILD>
    {{textTruncate$|async}}
  </span>
  @if (showOther$|async) {
    <span (click)="$event.stopPropagation();clickOther()" class="color-primary"
    style="cursor: pointer">{{'other'|translate}}...</span>
  }
</div>